import React, { useEffect, useRef } from 'react';
import OrgChart from '@balkangraph/orgchart.js';
import { useDispatch, useSelector } from 'react-redux';
import { getOrganigramma } from 'uniba-volto-persone/actions';
import { useLocation } from 'react-router-dom';
import { NUser, FUser, MUser } from 'uniba-volto-persone/theme/images';
import unibalogo from 'design-comuni-plone-theme/theme/images/uniba_logo.png';


const OrgChartComponent = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const chartContainer = useRef(null);
    const chartInstance = useRef(null);

    const path = location.pathname;

    React.useEffect(() => dispatch(getOrganigramma(path)), [dispatch, location]);
    const content = useSelector((state) => state.organigrammaReducer.items[path]);

    useEffect(() => {
        // Creo il template
        OrgChart.templates.uniba = Object.assign({}, OrgChart.templates.ana);
        OrgChart.templates.uniba.ripple = {
            radius: 0,
            color: "none",
            rect: null
        };
        const field_template = `<text data-text-overflow="ellipsis" data-width="350" width="490" x="10" y="200">{val}</text>`;
        OrgChart.templates.uniba.size = [500, 220];
        OrgChart.templates.uniba.link = '<path stroke-linejoin="round" stroke="#aeaeae" stroke-width="1px" fill="none" d="{curve}" />';
        OrgChart.templates.uniba.field_uo = '{val}';
        // `<text data-text-overflow="ellipsis" data-width="430" width="490" x="10" y="200">{val}</text>`;
        OrgChart.templates.uniba.field_nome =
            `<text data-text-overflow="ellipsis" data-width="240" width="300" x="200" y="40">{val}</text>`;
        OrgChart.templates.uniba.field_ruolo =
            `<text data-text-overflow="ellipsis" data-width="230" width="290" x="210" y="65">{val}</text>`;
        OrgChart.templates.uniba.node =
            '<rect x="0" y="0" height="220" width="500" rx="0" ry="0"></rect>';
        OrgChart.templates.uniba.img_0 =
            `<clipPath id="ulaImg"><circle cx="105" cy="65" r="85"></circle></clipPath>
            <image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="20" y="-20" width="170" height="170"></image>`;

        OrgChart.SEARCH_PLACEHOLDER = "Cerca all'interno dell'organigramma";
        // Inizializza l'organigramma solo una volta
        if (!chartInstance.current && chartContainer.current && content) {
            chartInstance.current = new OrgChart(chartContainer.current, {
                template: "uniba",
                enableSearch: true,
                toolbar: {
                    zoom: true,
                    fit: true,
                    expandAll: true
                },
                nodeMouseClick: OrgChart.action.none,
                orientation: OrgChart.orientation.left,
                scaleInitial: 0.8,
                enableEdit: false,
                enableGridView: true,
                enableMove: true,
                enablePrintable: true,
                levelSeparation: 500,
                siblingSeparation: 60,
                subtreeSeparation: 100,
                expandToLevel: 4,
                linkType: 'B',
                nodeBinding: {
                    field_uo: 'name',
                    field_nome: 'title',
                    field_ruolo: 'Ruolo',
                    img_0: 'image',
                    link: 'link',
                },
                nodes: content
            });

            chartInstance.current.on('field', function (sender, args) {
                if (args.name === "image") {
                    switch (args.value) {
                        case "M_user": args.value = MUser; break;
                        case "F_user": args.value = FUser; break;
                        case "N_user": args.value = NUser; break;
                        case "unibalogo": args.value = unibalogo; break;
                        default: break;
                    }
                }

                if (args.name == "name") {
                    args.value = `<a href="${args.data["link"]}?organigramma">
                                           ${field_template.replace('{val}', OrgChart.wrapText(args.data['name'], field_template))}                  
                                       </a>`;
                }
            });
        }

        // Pulizia al momento dello smontaggio
        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
                chartInstance.current = null;
            }
        };
    }, [content]);

    return (
        <div id="organigramma-aziendale">
            <h1 className='ms-3'>Organigramma Aziendale</h1>
            <div ref={chartContainer} style={{ width: '100%', height: '100%' }}></div>
        </div>
    );
};

export default OrgChartComponent;